export default __webpack_public_path__ + "static/upiOptions1-48fba0e9ae04603ba1e2287eb05a0802.webm";